import type { EChartsOption } from 'echarts';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { CSSProperties } from 'react';

import { echarts } from 'entities/analytics/lib/echarts';

type Props = {
  option: EChartsOption;
  height?: number;
  style?: CSSProperties;
};

export const EChart = ({ option, height = 280, style }: Props) => (
  <ReactEChartsCore
    echarts={echarts}
    option={option}
    notMerge
    lazyUpdate
    opts={{ renderer: 'canvas' }}
    style={{ height, width: '100%', ...style }}
  />
);
